import Layout from '@/layout';

const routes = [
  {
    name: 'transfer',
    path: '/transfer',
    component: () => import('@/views/transfer.vue')
  },
  {
    name: 'verity',
    path: '/verity',
    component: () => import('@/views/verity.vue')
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    name: 'replace',
    path: '/replace',
    component: () => import('@/views/replace.vue')
  },
  {
    path: '/',
    component: Layout,
    children: [
      // 首页
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home.vue')
      },
      // 故障工单
      {
        path: 'fault/work',
        name: 'work',
        component: () => import('@/views/fault/work/index.vue')
      },
      {
        path: 'fault/work/detail',
        name: 'work',
        component: () => import('@/views/fault/work/detail.vue')
      },
      {
        path: 'fault/work/detail/deal',
        name: 'work',
        component: () => import('@/views/fault/work/deal.vue')
      },
      // 工单上报
      {
        path: 'fault/report',
        name: 'report',
        component: () => import('@/views/fault/report/index.vue')
      },
      {
        path: 'fault/report/history',
        name: 'report',
        component: () => import('@/views/fault/report/history.vue')
      },
      {
        path: 'fault/report/history/detail',
        name: 'report',
        component: () => import('@/views/fault/report/detail.vue')
      },
    ]
  },
  {
    name: 'fourToFour',
    path: '/404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
];

export default routes;
